<template>
  <div class="sidebar-tivo">
    <sidebarProfileView />
    <div class="logo-icon-wrapper">
      <router-link to="/">
        <div class="icon-box-sidebar">
          <vue-feather type="grid"></vue-feather>
        </div>
      </router-link>
    </div>
    <navView />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import logoView from "./logoView.vue"
import navView from "./navView.vue"
import sidebarProfileView from "./sidebarProfileView.vue"
export default {
  components: {
    logoView,
    navView,
    sidebarProfileView
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      activeoverlay: (state) => state.menu.activeoverlay,
    }),
  },
  methods: {
    toggle_sidebar() {
      this.$store.dispatch('menu/opensidebar');
      this.$store.state.menu.activeoverlay = false;
    },
  },
}
</script>